import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const WarningModal = ({ show, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && show) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [show, onClose]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  const handleAddStaff = () => {
    onClose();
    navigate("/add_staff");
  };

  if (!show) return null;

  return (
    <>
      {/* Soft backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ 
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          transition: "all 0.3s ease"
        }}
        onClick={onClose}
      />
      
      {/* Modal */}
      <div 
        className="modal fade show" 
        style={{ 
          display: "block", 
          padding: "0 16px",
          animation: "slideUp 0.3s ease"
        }}
        onClick={(e) => e.target === e.currentTarget && onClose()}
      >
        <style>
          {`
            @keyframes slideUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
        
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "400px", margin: "0 auto" }}>
          <div className="modal-content" style={{ 
            borderRadius: "24px", 
            border: "none",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            overflow: "hidden"
          }}>
            {/* Content */}
            <div style={{ padding: "32px 24px", textAlign: "center" }}>
              {/* Icon */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{
                  width: "80px",
                  height: "80px",
                  background: "#FFF9E6",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto"
                }}>
                  <svg 
                    width="48" 
                    height="48" 
                    viewBox="0 0 24 24" 
                    fill="none"
                  >
                    <path 
                      d="M12 8V12M12 16H12.01M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z" 
                      stroke="#ffcb44" 
                      strokeWidth="1.5" 
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 style={{
                fontSize: "22px",
                fontWeight: "600",
                color: "#1F2937",
                marginBottom: "12px",
                letterSpacing: "-0.3px"
              }}>
                No Staff Members
              </h3>

              {/* Message */}
              <p style={{
                fontSize: "15px",
                color: "#6B7280",
                lineHeight: "1.5",
                marginBottom: "24px"
              }}>
               Add first staff to access the pos
              </p>

              {/* Buttons */}
              <div style={{ display: "flex", gap: "12px", flexDirection: "column" }}>
                <button
                  onClick={handleAddStaff}
                  style={{
                    width: "100%",
                    padding: "14px 20px",
                    background: "#ffcb44",
                    color: "white",
                    border: "none",
                    borderRadius: "40px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 8px rgba(245, 158, 11, 0.3)"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#D97706";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#ffcb44";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  + Add Staff Member
                </button>

                <button
                  onClick={onClose}
                  style={{
                    width: "100%",
                    padding: "12px 20px",
                    background: "transparent",
                    color: "#6B7280",
                    border: "1px solid #E5E7EB",
                    borderRadius: "40px",
                    fontSize: "15px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#F9FAFB";
                    e.target.style.borderColor = "#D1D5DB";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "transparent";
                    e.target.style.borderColor = "#E5E7EB";
                  }}
                >
                  Maybe Later
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WarningModal;